import * as React from 'react';
import { css } from '@emotion/core';
import { Str } from '../../../localization/translationKeys';
import { faUserPlus, faExclamationTriangle, faWrench, faEnvelope, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Z_INDEX } from '../../../globalStyle/zIndex';
import { COLORS } from '../../../globalStyle/colors';
import { btnStyle } from '../../../forms/styles/button';
import MobileToolbar from '../../../layout/mobile/MobileToolbar';
import MobileToolbarBtn from '../../../localization/MobileToolbarBtn';


const styles = {
  root:   css`
    justify-content: flex-end;
    width: 100vw;
    height: 72px;
    position: fixed;
    bottom: 0;
    z-index: ${Z_INDEX.MOBILE_TOOLBAR};
    background-color: ${COLORS.WHITE};
  `,
  button: css`
    height: auto;
    line-height: 12px;
    font-size: 9px;
    border-radius: 0;
    flex-basis: 80px;
    border-color: transparent;
    & > span {
      overflow-wrap: break-spaces;
      text-transform: uppercase;
    }
  `,
};


type Props = {
  className?: string;

  showPreviousRatersButton: boolean;
  showDirectorySearchButton: boolean;

  disableAddPreviousRatersButton: boolean;
  disableSearchDirectoryButton: boolean;
  disableCustomizeModalButton: boolean;
  disableRemindRatersButton: boolean;
  disableInviteOrApproveButton: boolean;

  customizeModalButtonLabel: Str;
  sendMsgButtonLabel: Str;

  onClickSearchDirectoryButton: () => void;
  onClickAddPreviousRatersButton: () => void;
  onClickSendRemindersButton: () => void;
  onClickCustomizeModalButton: () => void;
  onClickSendMsgButton: () => void;
}


/**
 * MobileRaterActionsBar: a tool bar which houses the action buttons associated with the invite-raters flow on mobile
 * screens.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const MobileRaterActionsBar: React.FC<Props> = props => (
  <MobileToolbar>
    {
      props.showPreviousRatersButton && (
        <MobileToolbarBtn
          css={[btnStyle.transparent(COLORS.DARK_GREY), styles.button]}
          str={Str.AddPreviousRaters}
          icon={faUserPlus}
          onClick={props.onClickAddPreviousRatersButton}
          disabled={props.disableAddPreviousRatersButton}
        />
      )
    }
    {
      props.showDirectorySearchButton && (
        <MobileToolbarBtn
          css={[btnStyle.transparent(COLORS.DARK_GREY), styles.button]}
          str={Str.SearchDirectory}
          icon={faSearch}
          onClick={props.onClickSearchDirectoryButton}
          disabled={props.disableSearchDirectoryButton}
        />
      )
    }
    <MobileToolbarBtn
      css={[btnStyle.transparent(COLORS.DARK_GREY), styles.button]}
      str={Str.RemindRaters}
      icon={faExclamationTriangle}
      onClick={props.onClickSendRemindersButton}
      disabled={props.disableRemindRatersButton}
    />
    <MobileToolbarBtn
      css={[btnStyle.transparent(COLORS.DARK_GREY), styles.button]}
      str={props.customizeModalButtonLabel}
      icon={faWrench}
      onClick={props.onClickCustomizeModalButton}
      disabled={props.disableCustomizeModalButton}
    />
    <MobileToolbarBtn
      css={[btnStyle.primary(COLORS.GREEN), styles.button]}
      str={props.sendMsgButtonLabel}
      icon={faEnvelope}
      onClick={props.onClickSendMsgButton}
      disabled={props.disableInviteOrApproveButton}
    />
  </MobileToolbar>
);

export default MobileRaterActionsBar;
